import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface SpecialModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const SpecialModal = ({ isVisible, onClose }: SpecialModalProps) => {
  if (!isVisible) return null;

  return (
    <div className={cx("modalOverlay")} onClick={onClose}>
      <div className={cx("modalContent")} onClick={(e) => e.stopPropagation()}>
        <h2>🎉 축하합니다!</h2>
        <p>관계자에게 화면을 보여주세요!!</p>
        <button className={cx("closeBtn")} onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  );
};

export default SpecialModal;
